import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Button, DataTable, Heading } from "grommet";
import { get } from "lodash";
import React, { useEffect } from "react";
import { getOverallUsage, OrganizationUsageDetail } from "./BillingStore";

import * as XLSX from "xlsx";
import { Routes, Route } from "react-router-dom";
import OrganizationUsage from "./OrganizationUsage";
import OverallUsage from "./OverallUsage";

const BillingManagement = () => {
    return (
        <>
            <Heading size="sm">Billing</Heading>
            <Routes>
                <Route path="/" element={<OverallUsage />} />
                <Route path="/organization/:id" element={<OrganizationUsage />} />
            </Routes>
        </>
    );
};

export default BillingManagement;
